
import { Button } from "@/components/ui/button";
import { Phone, Calendar, MessageCircle } from "lucide-react";

const ActionButtons = () => {
  const handleCallClick = () => {
    // Fire GTM event for call click
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'cta_call_click' });
    }
    
    window.location.href = 'tel:+4915754767196';
  };

  const handleZoomClick = () => {
    // Fire GTM event for Zoom click
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'cta_zoom_click' });
    }
    
    // Also open WhatsApp asking for Zoom meeting link
    window.open('https://wa.me/4915754767196?text=' + encodeURIComponent('Hi, can you share the Zoom meeting link?'), '_blank');
  };

  const handleChatClick = () => {
    // Fire GTM event for chat open click
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'cta_chat_open_click' });
    }
    
    // Trigger WhatsApp widget
    window.dispatchEvent(new CustomEvent('showWhatsAppWidget'));
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <Button 
        onClick={handleCallClick}
        className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 font-semibold flex items-center justify-center gap-2"
      >
        <Phone className="w-4 h-4" />
        Call Now
      </Button>
      <Button 
        onClick={handleZoomClick}
        className="bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 font-semibold flex items-center justify-center gap-2"
      >
        <Calendar className="w-4 h-4" />
        Join Zoom
      </Button>
      <Button 
        onClick={handleChatClick}
        className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 font-semibold flex items-center justify-center gap-2"
      >
        <MessageCircle className="w-4 h-4" />
        Live Chat
      </Button>
    </div>
  );
};

export default ActionButtons;
